import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { BlobModel } from '../../models/blob.model';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { PostValueResponseModel } from '../../models/core/post-value-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { UrlParameterModel } from '../../models/core/url-parameter.model';

@Injectable({
    providedIn: 'root'
})
export class BlobsResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'blobs' }));
    }

    upload(data: BlobModel): Observable<PostValueResponseModel> {
        return this._requestService.makePost<PostValueResponseModel>(this.getUrl(''), data);
    }

    download(key: string): Observable<ApiResponseModel<string>> {
        return this._requestService.makeGet<ApiResponseModel<string>>(this.getUrl(key));
    }

    deleteKeys(keys: string[]): Observable<ApiResponseModel<boolean>> {
        const params = keys.map(k => new UrlParameterModel({ key: 'keys', value: k }));

        return this._requestService.makeDeleteMany<ApiResponseModel<boolean>>(
            this.getUrl(''),
            params,
            undefined,
            undefined,
            false,
            undefined
        );
    }
}
